module.exports = __webpack_public_path__ + "img/ventas-slick.15eab564.svg";